import { render, staticRenderFns } from "./MediaCategoryFilter.vue?vue&type=template&id=1a9ae65b&"
import script from "./MediaCategoryFilter.vue?vue&type=script&lang=js&"
export * from "./MediaCategoryFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports